import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';

@Pipe({
    name: 'translateDate',
    pure: false,
})
export class TranslateDatePipe implements PipeTransform {
    readonly DEFAULT_LANG = this.localizationService.defaultLanguage;

    constructor(private readonly localizationService: LocalizationService) {}

    transform(value: Date | string, format = 'mediumDate'): string | null {
        const datePipe = new DatePipe(
            this.localizationService.getCurrentLanguage()
        );
        return datePipe.transform(value, format);
    }
}
